import React, { useState, useEffect, Fragment, useMemo } from 'react';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';
import { makeStyles } from '@material-ui/core/styles';
import moment from 'moment';

//iconos
import { Assignment, Map, Search, Visibility, List as ListIcon } from '@material-ui/icons';

//tabla y card components
import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';
import Button from 'components/CustomButtons/Button.js';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import ReactTable from 'components/ReactTable/ReactTable.js';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';

//servicios
import { wsFindBy, wsGetAll } from 'services/WService';

//component
import { Toasty, useToasty } from 'hooks/Toasty';
import { WithApp } from 'contexts/appContext';

import ModalGps from '../Modal/Modal';
import Filter from 'components/Tvendo/Common/FilterCustom';
import { currency } from 'hooks/Pipe';
import { LayerColorIcon } from 'components/Tvendo/Common/LayerCombo';
import { useLocation, useNavigate } from 'react-router-dom';
import MultiComplete from 'components/Tvendo/Common/MultiComplete';
import TrackingMap from './TrackingMap';
import { Checkbox, FormControlLabel, TextField } from '@material-ui/core';

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px',
    fontSize: '16px',
    display: 'flex',
    justifyContent: 'space-between',
  },
  headerCard: {
    fontSize: '.9em',
    '& .totals': {
      marginLeft: '20px',
      fontWeight: 'bold',
      color: 'black',
    },
  },
};
const useStyles = makeStyles(styles);

const dailyColumns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 75 },
  { Header: 'Intervalo de visitas', accessor: 'interval', width: 200, excelEnabled: false },
  { Header: 'Fecha', accessor: 'periodDate', width: 120 },
  { Header: '', accessor: 'color', width: 1, isColor: true, hidden: true },
  { Header: 'Nombre vendedor', accessor: 'SlpName', width: 300 },
  { Header: 'Mesa', accessor: 'base_bureau_description', width: 200 },
  { Header: 'Zona', accessor: 'base_zone_description', width: 120 },

  { Header: 'Cuota', accessor: 'quota', width: 150, filterKey: 'without_igv' },
  { Header: 'Venta', accessor: 'progress', width: 150, filterKey: 'without_igv' },
  { Header: '% Avance', accessor: 'progress_percentage', width: 120, filterKey: 'without_igv' },

  { Header: 'Cuota IGV', accessor: 'quota_igv', width: 150, filterKey: 'with_igv' },
  { Header: 'Venta IGV', accessor: 'progress_igv', width: 150, filterKey: 'with_igv' },
  {
    Header: '% Avance IGV',
    accessor: 'progress_percentage_igv',
    width: 120,
    filterKey: 'with_igv',
  },

  { Header: 'Pedidos', accessor: 'orders', width: 130 },
  { Header: 'No Pedidos', accessor: 'no_orders', width: 130 },
  { Header: 'Ped. Cerca Punto', accessor: 'orders_near_address', width: 175 },
  { Header: 'Inicio Jornada', accessor: 'work_day', width: 130 },
  { Header: 'Inicio Operaciones', accessor: 'start_operation', width: 130 },
  { Header: 'Dentro.Ruta', accessor: 'within_route', width: 130 },
  { Header: 'P.Pedido en Ruta', accessor: 'first_order_in_route', width: 175 },
  { Header: 'U.Pedido en Ruta', accessor: 'last_order_in_route', width: 175 },
  { Header: 'Primer pedido', accessor: 'first_order', width: 130 },

  { Header: 'T. Clientes', accessor: 'tCustomer', width: 120 },
  { Header: 'Cli. vendidos', accessor: 'customerSales', width: 120 },
  { Header: 'Cli. Visitados', accessor: 'customerVisit', width: 120 },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 },
];

const periodColumns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 75 },
  // { Header: 'Intervalo de visitas', accessor: 'interval', width: 200, excelEnabled: false },
  { Header: 'Periodo', accessor: 'periodDate', width: 120 },
  { Header: '', accessor: 'color', width: 1, isColor: true, hidden: true },
  { Header: 'Nombre vendedor', accessor: 'SlpName', width: 300 },
  { Header: 'Mesa', accessor: 'base_bureau_description', width: 200 },
  { Header: 'Zona', accessor: 'base_zone_description', width: 120 },

  { Header: 'Cuota', accessor: 'quota', width: 160, filterKey: 'without_igv' },
  { Header: 'Venta', accessor: 'progress', width: 160, filterKey: 'without_igv' },
  { Header: '% Avance', accessor: 'progress_percentage', width: 130, filterKey: 'without_igv' },

  { Header: 'Cuota IGV', accessor: 'quota_igv', width: 160, filterKey: 'with_igv' },
  { Header: 'Venta IGV', accessor: 'progress_igv', width: 160, filterKey: 'with_igv' },
  {
    Header: '% Avance IGV',
    accessor: 'progress_percentage_igv',
    width: 130,
    filterKey: 'with_igv',
  },

  // { Header: 'Pedidos', accessor: 'orders', width: 130 },
  // { Header: 'No Pedidos', accessor: 'no_orders', width: 130 },
  // { Header: 'Inicio Jornada', accessor: 'work_day', width: 130 },
  // { Header: 'Dentro.Ruta', accessor: 'within_route', width: 130 },
  // { Header: 'P.Pedido en Ruta', accessor: 'first_order_in_route', width: 175 },
  // { Header: 'U.Pedido en Ruta', accessor: 'last_order_in_route', width: 175 },
  // { Header: 'Primer pedido', accessor: 'first_order', width: 130 },

  { Header: 'T. Clientes', accessor: 'tCustomer', width: 120 },
  { Header: 'Cli. vendidos', accessor: 'customerSales', width: 120 },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 },
];

const resumeColumns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 75 },
  { Header: 'Fecha', accessor: 'periodDate', width: 120 },
  { Header: 'Nombre vendedor', accessor: 'SlpName', width: 400 },
  { Header: 'Venta', accessor: 'progress', width: 250, filterKey: 'without_igv' },
  { Header: 'Venta IGV', accessor: 'progress_igv', width: 250, filterKey: 'with_igv' },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 },
];

export default WithApp(function SellerTracing(props) {
  const classes = useStyles();
  const [notify, showNotify] = useToasty();
  const location = useLocation();
  const navigate = useNavigate();

  const [viewMapTracking, setViewMapTracking] = useState(false);
  const [sellersGps, setSellersGps] = useState([]);
  const [routesGps, setRoutesGps] = useState([]);
  const [fromTime, setFromTime] = useState(moment().add(-30, 'minutes').format('HH:mm'));
  const [toTime, setToTime] = useState(moment().format('HH:mm'));

  const [valueSearch, setValueSearch] = useState({});
  const [processing, setProcessing] = useState(false);
  const [open, setOpen] = useState(false);
  const [bureaus, setBureaus] = useState([]);
  const [igvFilterKey, setIgvFilterKey] = useState('with_igv');
  const [viewResume, setViewResume] = useState(false);
  const [dataLoading, setDataLoading] = useState(false);

  const filteredBureaus = useMemo(() => {
    if (valueSearch.base_zone_id === undefined) return bureaus;
    return bureaus.filter((bureau) => parseInt(bureau.base_zone_id) === valueSearch.base_zone_id);
  }, [bureaus, valueSearch.base_zone_id]);

  const [sellers, setSellers] = useState([]);
  const [seller, setSeller] = useState({});
  const [checked, setChecked] = useState(false);
  

  const columns = useMemo(() => {
    if (viewResume) {
      return resumeColumns;
    }
    let columns = checked ? periodColumns : dailyColumns;
    columns = columns.filter((column) => {
      if (column.filterKey === undefined) return true;
      return column.filterKey === igvFilterKey;
    });
    return columns;
  }, [checked, igvFilterKey, viewResume]);

  const [selectedBureaus, setSelectedBureaus] = useState([]);
  useEffect(() => {
    setSelectedBureaus([]);
  }, [valueSearch.base_zone_id]);
  // Canales
  const [canals, setCanals] = useState([]);
  const [selectedCanals, setSelectedCanals] = useState([]);

  const [trackingConfig, setTrackingConfig] = useState({
    inicioSeguimiento: '7:00',
    minutosMayorista: 7.5,
    minutosMinorista: 15,
    porcentajeIntervalo: 10,
  });

  

  async function listSellers(search) {
    if (viewMapTracking) {
      return listSellersGps();
    }

    checked ? (search.type = 'P') : (search.type = 'D');
    let date = search.date;
    if (search.type === 'P') {
      date = moment(search.date).format('YYYY-MM');
    } else {
      date = moment(search.date).format('YYYY-MM-DD');
    }
    let bureaus = selectedBureaus.map((bureau) => bureau.id);
    let canals = selectedCanals.map((canal) => canal.id);

    setDataLoading(true);
    setProcessing(true);
    setSellers([]);
    let response = await wsFindBy('base/quota/seller', {
      ...search,
      date,
      bureaus,
      canals,
    });
    setProcessing(false);
    setDataLoading(false);
    if (response.success) {
      setSellers(response.data);

      if (
        location.search.length > 0 &&
        new URLSearchParams(location.search).get('sellerId') !== null
      ) {
        let sellerId = new URLSearchParams(location.search).get('sellerId');
        let seller = response.data.find((seller) => seller.base_seller_id === sellerId);
        if (seller) {
          setSeller(seller);
          setOpen(true);
        }
      }

      setTrackingConfig({
        inicioSeguimiento: response.inicioSeguimiento,
        minutosMayorista: response.minutosMayorista,
        minutosMinorista: response.minutosMinorista,
        porcentajeIntervalo: response.porcentajeIntervalo,
      });
    }
  }

  const totals = useMemo(() => {
    let totals = sellers.reduce(
      (carry, seller) => {
        carry.quota += parseFloat(
          (igvFilterKey === 'without_igv' ? seller.quota : seller.quota_igv) || 0,
        );
        carry.sales += parseFloat(
          (igvFilterKey === 'without_igv' ? seller.progress : seller.progress_igv) || 0,
        );
        return carry;
      },
      {
        quota: 0,
        sales: 0,
      },
    );
    return {
      quota: parseFloat(totals.quota || 0).toFixed(2),
      sales: parseFloat(totals.sales || 0).toFixed(2),
      progress: parseFloat((totals.sales / totals.quota) * 100 || 0).toFixed(2),
    };
  }, [sellers, igvFilterKey]);

  async function listSellersGps() {
    let bureaus = selectedBureaus.map((bureau) => bureau.id);
    let canals = selectedCanals.map((canal) => canal.id);
    setDataLoading(true);
    setProcessing(true);
    setSellersGps([]);
    setRoutesGps([]);
    let response = await wsFindBy('base/tracking', {
      bureaus,
      canals,
      from_minutes: fromTime,
      to_minutes: toTime,
    });
    setProcessing(false);
    setDataLoading(false);
    if (response.success) {
      setSellersGps(response.data.sellers);
      setRoutesGps(response.data.routes);
    }
  }

  async function listBureaus() {
    setDataLoading(true);
    let res = await wsGetAll('base/bureau');
    setDataLoading(false);
    if (res.success) setBureaus(res.data);
  }

  async function listCanals() {
    setDataLoading(true);
    let res = await wsGetAll('base/canal');
    setDataLoading(false);
    if (res.success) {
      setCanals(res.data);
      setSelectedCanals(res.data);
    }
  }

  function handleOpenGps(seller) {
    navigate(`${location.pathname}?sellerId=${seller.base_seller_id}`, { replace: true });
    setOpen(true);
    setSeller(seller);
  }

  useEffect(() => {
    listBureaus();
    listCanals();
  }, []);

  useEffect(() => {
    setSellers([]);
  }, [checked]);

  return (
    <GridContainer>
      <Toasty action={notify} />
      <ModalGps
        nameList="seller"
        open={open}
        setOpen={setOpen}
        dataList={seller}
        setDataList={setSeller}
        dateFilter={valueSearch.date}
        showNotify={showNotify}
      />
      <GridItem xs={12}>
        <Card>
          <CardHeader icon>
            <CardIcon color={props.themeContext.buttonColor}>
              <Assignment />
            </CardIcon>
            <div className={classes.cardIconTitle}>
              Elija un vendedor para ver su recorrido
              <div className={classes.headerCard}>
                <span className="totals">Avance: {totals.progress}%</span>
                <span className="totals">Venta: {currency(totals.sales)}</span>
                <span className="totals">Cuota: {currency(totals.quota)}</span>
              </div>
            </div>
              {dataLoading && <LoadingSpinner />}
          </CardHeader>
          <CardBody>
            <GridContainer>
              <GridItem xs={12}>
                <Filter
                  getFilter={setValueSearch}
                  date
                  dateType={checked ? 'month' : 'date'}
                  zone
                  disabled={processing}
                >
                  <GridItem
                    xs={12}
                    md={1}
                    style={{
                      display: 'flex',
                      alignItems: 'flex-end',
                      justifyContent: 'flex-end',
                    }}
                  >
                    {processing && <div className="lds-dual-ring"></div>}
                    <Button
                      size="sm"
                      color={
                        checked
                          ? props.themeContext.buttonColor
                          : props.themeContext.buttonColorWarning
                      }
                      disabled={processing}
                      onClick={() => setChecked(!checked)}
                    >
                      {checked ? 'Periodo' : 'Día'}
                    </Button>
                  </GridItem>
                </Filter>
              </GridItem>
              <GridItem xs={12} sm={6} md={3}>
                <MultiComplete
                  label="Mesa"
                  selectAll
                  limitTags={1}
                  textField="description"
                  options={filteredBureaus}
                  disabled={processing}
                  selected={selectedBureaus}
                  setSelected={setSelectedBureaus}
                />
              </GridItem>
              <GridItem xs={12} sm={6} md={3}>
                <MultiComplete
                  label="Canal"
                  selectAll
                  limitTags={2}
                  textField="description"
                  options={canals}
                  disabled={processing}
                  selected={selectedCanals}
                  setSelected={setSelectedCanals}
                />
              </GridItem>
              <GridItem xs={12} sm={6} md={3}>
                <FormControlLabel
                  label="Ver con igv"
                  control={
                    <Checkbox
                      margin="normal"
                      checked={igvFilterKey === 'with_igv'}
                      onChange={(_) => {
                        setIgvFilterKey((key) => {
                          if (key === 'with_igv') return 'without_igv';
                          return 'with_igv';
                        });
                      }}
                    />
                  }
                />
              </GridItem>
              <GridItem xs={12} sm={6} md={3}>
                <FormControlLabel
                  label="Ver resumen"
                  control={
                    <Checkbox
                      margin="normal"
                      checked={viewResume}
                      onChange={(_) => setViewResume((resume) => !resume)}
                    />
                  }
                />
              </GridItem>

              {viewMapTracking && (
                <Fragment>
                  <GridItem xs={6} sm={3} md={2} lg={1}>
                    <TextField
                      fullWidth
                      label="Desde las"
                      type="time"
                      margin="normal"
                      InputLabelProps={{ shrink: true }}
                      variant="standard"
                      value={fromTime}
                      onChange={(e) => {
                        setFromTime(e.target.value);
                      }}
                    />
                  </GridItem>
                  <GridItem xs={6} sm={3} md={2} lg={1}>
                    <TextField
                      fullWidth
                      label="Hasta las"
                      type="time"
                      margin="normal"
                      InputLabelProps={{ shrink: true }}
                      variant="standard"
                      value={toTime}
                      onChange={(e) => {
                        setToTime(e.target.value);
                      }}
                    />
                  </GridItem>
                </Fragment>
              )}
              <GridItem xs={3}>
                <Button
                  color="primary"
                  justIcon
                  round
                  disabled={selectedBureaus.length === 0 || selectedCanals.length === 0}
                  onClick={() => listSellers(valueSearch)}
                >
                  <Search />
                </Button>
                <Button
                  color="success"
                  justIcon
                  round
                  onClick={() => setViewMapTracking((view) => !view)}
                >
                  {!viewMapTracking ? <Map /> : <ListIcon />}
                </Button>
              </GridItem>
            </GridContainer>

            {!viewMapTracking ? (
              <ReactTable
                excelName="Seguimiento-de-vendedor"
                formatDate="DD-MM-YYYY"
                defaultWidth={viewResume ? 800 : checked ? 1450 : 3150}
                columns={columns}
                data={sellers.map((seller, i) => {
                  let minutos =
                    seller.base_canal_id === '1'
                      ? trackingConfig.minutosMinorista
                      : trackingConfig.minutosMayorista;
                  let margen = (minutos / 100) * trackingConfig.porcentajeIntervalo;

                  let color = 'DCD500'; // Amarillo
                  if (seller.intervalo_visitas === null) {
                    color = '900000'; // Negro
                  } else if (seller.intervalo_visitas < minutos - margen) {
                    color = '14BD00'; // Verde
                  } else if (seller.intervalo_visitas > minutos + margen) {
                    color = '900000'; // Rojo
                  }

                  let igvData;
                  if (viewResume) {
                    igvData = {
                      progress: currency(seller.progress),
                      progress_igv: currency(seller.progress_igv),
                    };
                  } else if (igvFilterKey === 'without_igv') {
                    igvData = {
                      quota: currency(seller.quota),
                      progress: currency(seller.progress),
                      progress_percentage: seller.progress_percentage,
                    };
                  } else {
                    igvData = {
                      quota_igv: currency(seller.quota_igv),
                      progress_igv: currency(seller.progress_igv),
                      progress_percentage_igv: seller.progress_percentage_igv,
                    };
                  }

                  return {
                    num: !checked ? (
                      <div className="actions-right">
                        {i + 1}
                        <AllowedGuard permission={ConstantPermissions.BASE_SELLERS_QUOTA_SHOW}>
                          <Button
                            justIcon
                            round
                            simple
                            color={props.themeContext.buttonColor}
                            onClick={() => handleOpenGps(seller)}
                          >
                            <Visibility />
                          </Button>
                        </AllowedGuard>
                      </div>
                    ) : (
                      i + 1
                    ),
                    interval: (
                      <>
                        {seller.intervalo_visitas === null ? (
                          'Sin visitas'
                        ) : (
                          <>
                            <LayerColorIcon
                              layer={{ color: `#${color}` }}
                              alpha="99"
                              style={{ display: 'inline-block' }}
                            />{' '}
                            <span>
                              Cada {seller.intervalo_visitas} min (De {minutos})
                            </span>
                          </>
                        )}
                      </>
                    ),
                    periodDate: checked ? seller.date : seller.date,
                    color: color,
                    SlpName: seller.SlpName,
                    base_bureau_description: seller.base_bureau_description,
                    base_zone_description: seller.base_zone_description,
                    //Campos de valores igv / sin-igv
                    ...igvData,
                    orders: seller.orders,
                    no_orders: seller.no_orders,
                    orders_near_address: seller.orders_near_address,
                    work_day:
                      seller.work_day === null
                        ? 'Jornada no iniciada'
                        : moment(seller.work_day).format('HH:mm'),
                    start_operation:
                      seller.start_operation === null
                        ? 'Sin iniciar'
                        : moment(seller.start_operation).format('HH:mm'),
                    within_route: parseInt(seller.within_route) === 1 ? 'Si' : 'No',
                    first_order_in_route:
                      seller.first_order_in_route === null
                        ? '-'
                        : moment(seller.first_order_in_route).format('HH:mm'),
                    last_order_in_route:
                      seller.last_order_in_route === null
                        ? '-'
                        : moment(seller.last_order_in_route).format('HH:mm'),
                    first_order:
                      seller.first_order === null
                        ? 'Sin pedidos'
                        : moment(seller.first_order).format('HH:mm'),

                    tCustomer: seller.total_customers,
                    customerSales: seller.selled_customers,
                    customerVisit: seller.visited_customers,

                    actions: '',
                  };
                })}
              />
            ) : (
              <TrackingMap sellers={sellersGps} routes={routesGps} />
            )}
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
});
//total de clientes,
//clientes vendidos,
//clientes visitados
